$(document).ready(function() {
    $('.datepicker').datepicker({
        dateFormat: "dd-mm-yyyy",
        changeMonth : true,
        changeYear: true
    });
})